import { type ComponentType, type ReactNode, Suspense } from 'react';

interface WithSuspenseOptions<TProps> {
  fallback?: ReactNode;
  defaultProps?: Partial<TProps>;
}

export const withSuspense = <TProps extends object>(
  Component: ComponentType<TProps>,
  options: WithSuspenseOptions<TProps> = {},
) => {
  const { fallback = null, defaultProps } = options;

  const WrappedComponent = (props: TProps) => (
    <Suspense fallback={fallback}>
      <Component {...defaultProps} {...props} />
    </Suspense>
  );

  WrappedComponent.displayName = `withSuspense(${Component.displayName || Component.name || 'Component'})`;

  return WrappedComponent;
};
